import { Typography } from "@mui/material";
import "../../assets/css/error.css"
const Error = () => {
  return (
    <div className="error-container">
      <div className="error-content">
        <Typography variant="h1" className="error-title" fontWeight={900}>
          404
        </Typography>
        <Typography variant="h2" className="error-subtitle">
          Error
        </Typography>
      </div> 
    </div>
  );
};

export default Error;